import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { init, Router } from "@maxeb/admin-ui";

const palette = {
  primary: "#5c90d2",
  secondary: "#2c689c",
  tertiary: "#212a37",
  danger: "#b7433f",
  success: "#559554",
  warning: "#e8db05",
  default: "#ececec",
  grey: "#e0e0e0",
  mediumGrey: "#a8a8a8",
  darkgrey: "#7d7d7d",
  font: "#3e3e3e",
  background: "#ececec",
  formLabel: "#797979",
  formBackground: "#ececec",
  formBackgroundActive: "#e0e0e0",
  section: "#717171",
};

init({ palette: palette });

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
